import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { appstraxAuth } from '@appstrax/services/auth';
import { User } from '@models';

import { UserActions } from './user.actions';

const userLoadCurrent$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(UserActions.loadCurrent),
      switchMap(() =>
        from(appstraxAuth.getUser()).pipe(
          map((authUser) => {
            const user = new User();
            user.id = authUser.id;
            user.email = authUser.email;
            return UserActions.loadCurrentSucceeded({ user });
          }),
          catchError((e) => of(UserActions.loadCurrentFailed({ error: e?.message ?? 'Failed to load user' })))
        )
      )
    ),
  { functional: true }
);

export const userEffects = {
  userLoadCurrent$,
};
